import { REQUESTED, SUCCESS, FAILED, HTTP_ACTION } from '../constants';

export const httpMiddleware = store => next => action => {
  if (action[HTTP_ACTION]) {
    const actionInfo = action[HTTP_ACTION];
    let initialState = actionInfo.initialStates;
    const fetchOptions = {
      method: actionInfo.verb,
      headers: actionInfo.headers,
      response: actionInfo.response,
      initialState
    };
    if (actionInfo.verb !== 'GET') {
      fetchOptions.body = actionInfo.response || null
    }
    next({
      type: actionInfo.type
    });
    fetch(actionInfo.endpoint, fetchOptions)
      .then(handleErrors)
      .then(response => response.json())
      .then(data => { //console.log(" data success "+ JSON.stringify(data));
        if (data.status == 'success') {
          next({
            type: actionInfo.type + '_SUCCESS',
            result: data,
            response: actionInfo.response,
            initialState
          })
        } else {
          next({
            type: actionInfo.type + '_FAILURE',
            result: data,
            response: actionInfo.user,
            initialState
          })
        }
      })
      .catch(error => {
        next({
          type: actionInfo.type + '_FAILURE',
          result: error,
          initialState
        })
      });
  } else {
    return next(action);
  }
}
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  } //else if(!response.)
  return response;
}
